import { useMemo } from 'react'
import { useLimitSwapAmount, useLimitSwapPair } from '~/state/dex/hooks'
import { useLimitOrderAllowance } from './useLimitOrderAllowance'
import { maxUint256 } from 'viem'
import BigNumber from 'bignumber.js'
import { FixedPointNumber } from '~/utils/fixedPoint'
import { toBigNumberWithDecimal } from '~/utils/numbers'
import { LimitOrderStatus, useUserLimitOrderList } from '~/hooks'

export const useNeedApprove = () => {
  const [inputToken] = useLimitSwapPair()
  const { inputAmount } = useLimitSwapAmount()
  const allowance = useLimitOrderAllowance(inputToken)
  const decimals = inputToken?.decimals

  const { data: limitOrders } = useUserLimitOrderList([
    LimitOrderStatus.Pending,
    LimitOrderStatus.PartialFilled,
  ])

  const activeOrderBalance = (limitOrders || [])
    .filter(
      (order) =>
        order.makerToken.toLowerCase() === inputToken?.address.toLowerCase(),
    )
    .reduce((acc, order) => {
      return acc.plus(
        (order.status === LimitOrderStatus.Pending
          ? order.makerTokenAmount
          : order.remainInputAmountToDeal) || 0,
      )
    }, new BigNumber(0))

  const needApprove = useMemo(() => {
    if (!allowance) return false
    if (allowance.eq(maxUint256.toString())) return false
    let amount = isNaN(Number(inputAmount)) ? '0' : String(inputAmount || 0)
    // @notice: amount 是计算值，可能会出现小数位数大于 token 的 decimal 的情况，需要先保护一下
    amount = new BigNumber(amount).decimalPlaces(decimals).toString()
    const formattedAllowance = toBigNumberWithDecimal(allowance, decimals)
    const formattedActiveOrderBalance = toBigNumberWithDecimal(
      activeOrderBalance,
      decimals,
    )
    if (
      new FixedPointNumber(amount, decimals).gt(
        formattedAllowance.minus(formattedActiveOrderBalance),
      )
    )
      return true
    return false
  }, [inputAmount, allowance, inputToken, activeOrderBalance])

  return needApprove
}
